import { EmbeddedQuery, EmbeddedQueryParser } from './EmbeddedQueryParser';
import Event from './Event';
import { INavigationService, PageLoadedEventArgs } from './NavigationService';
import { RelativeUrl } from './Url';

export class KeepEmbeddedModeProxy implements INavigationService {
  private navigation: INavigationService;
  private queryModel: EmbeddedQuery;

  public pageLoaded = new Event<PageLoadedEventArgs>();

  get referrer() {
    return this.navigation.referrer;
  }

  constructor(navigation: INavigationService) {
    this.navigation = navigation;
    this.pageLoaded.subscribe((x) => this.navigation.pageLoaded.raise(x));

    this.queryModel = EmbeddedQueryParser.toModel(this.currentUrl.query);
  }

  navigateTo(url: RelativeUrl): void {
    let targetUrl = url;

    if (this.queryModel.embed) {
      targetUrl = url.clone();
      targetUrl.setQuery(this.modifyQueryIfNeeded(targetUrl.query));
    }

    this.navigation.navigateTo(targetUrl);
  }

  redirect(url: string): void {
    this.navigation.redirect(url);
  }

  setQuery(query: Map<string, string>) {
    this.navigation.setQuery(this.modifyQueryIfNeeded(query));
  }

  reload() {
    this.navigation.reload();
  }

  back() {
    this.navigation.back();
  }

  get currentUrl() {
    return this.navigation.currentUrl;
  }

  set currentUrl(url: RelativeUrl) {
    this.navigation.currentUrl = url;
  }

  private modifyQueryIfNeeded(query: Map<string, string>): Map<string, string> {
    let targetQuery = query;

    if (this.queryModel.embed) {
      targetQuery = new Map(query);
      EmbeddedQueryParser.buildUpQuery(this.queryModel, targetQuery);
    }

    return targetQuery;
  }
}
